import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/opportunities")({
  component: () => <Outlet />,
  context: () => ({ permissions: "opportunities" }),
});
